<template>
  <BuildingSectionCard
    title="Deposits & fees"
    tone="secondary"
    :hint="`${unitDefaultHint} Monthly rent is each unit's own and is set on the unit.`"
    :form="LeaseConditionsForm"
    :has-info="Boolean(conditions?.securityDeposit)"
    :placeholder="{
      title: 'No default deposits & fees yet',
      subtitle: 'New units start with no deposit or fees until you set a default. Monthly rent is set on each unit.',
      buttonText: 'Add deposits & fees',
    }"
  >
    <template v-if="conditions?.securityDeposit" #subtitle>
      <DefaultDriftLine
        :building-id="building.id"
        :differing-ids="building.defaultsDrift?.depositsAndFees"
        :units="units"
      />
    </template>

    <template v-if="conditions">
      <PropertyDetailsCardRows>
        <!-- The one line of this card a building never fills in -->
        <PropertyDetailsCardInfoItem label="Monthly rent" icon="currency-dollar-circle">
          <Text variant="body-medium" color="tertiary">Set on each unit</Text>
        </PropertyDetailsCardInfoItem>
        <PropertyDetailsCardInfoItem
          v-if="conditions.securityDeposit"
          label="Security deposit"
          icon="bank-note-01"
          :value="rentMultipleLabel(conditions.securityDeposit)"
        />
        <PropertyDetailsCardInfoItem
          v-if="conditions.applicationProvider"
          label="Application provider"
          icon="file-check-02"
          :value="conditions.applicationProvider"
        />
        <template v-if="conditions.applicationProvider === ApplicationProvider.OTHER">
          <PropertyDetailsCardInfoItem
            v-if="conditions.applicationFee !== null"
            label="Application fee"
            icon="wallet-02"
            :value="`$${conditions.applicationFee}`"
          />
          <PropertyDetailsCardInfoItem
            v-if="conditions.applicationCoSignerFee !== null"
            label="Co-signer fee"
            icon="users-01"
            :value="`$${conditions.applicationCoSignerFee}`"
          />
        </template>
      </PropertyDetailsCardRows>
      <PropertyNotes :text="conditions.otherFees" label="Other fees" />
    </template>
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';
import { BuildingDto, LeaseConditionsForm, PropertyListItemDto, rentMultipleLabel } from '@tallo/investor/property';
import {
  ApplicationProvider,
  PropertyDetailsCardInfoItem,
  PropertyDetailsCardRows,
  PropertyNotes,
} from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';
import DefaultDriftLine from '../default-drift-line.vue';
import { unitDefaultHint } from './unit-default.const';

/** The deposit and fees a new unit starts with; the monthly rent is each unit's own */
const props = defineProps<{ building: BuildingDto; units: PropertyListItemDto[] }>();

const conditions = computed(() => props.building.leaseConditions);
</script>
